export default function getFlattenedResponses(obj, flattened = {}) {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value.hasOwnProperty("recursive_question_value")) {
      // Recursively call the function on each 'recursive_question_value'
      value["recursive_question_value"]?.forEach((child) =>
        getFlattenedResponses(child, flattened)
      );
    }
    // Add the object to the new object
    // Avoid overwriting existing values in 'flattened'
    if (!flattened.hasOwnProperty(key)) {
      flattened[key] = !value.hasOwnProperty("recursive_question_value")
        ? {}
        : value;
    }
  });
  return flattened;
}
